import { useRenderNode } from "./useRenderNode";

export const CraftJsonRenderer = ({ craftJson }: any) => {
  const renderNode = useRenderNode();
  const parseCraft = JSON.parse(craftJson);
  return renderNode(parseCraft["ROOT"], parseCraft);
};
